module.exports = __webpack_public_path__ + "img/portraits_28_V.c82baa2f.webp";